import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "17.111"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#999" }, [
      _createElementVNode("path", {
        d: "M7 7.778a3.889 3.889 0 1 0-3.889-3.889A3.89 3.89 0 0 0 7 7.778m0-6.222a2.333 2.333 0 1 1-2.333 2.333A2.333 2.333 0 0 1 7 1.556",
        "data-name": "Path 1709"
      }),
      _createElementVNode("path", {
        d: "M.778 17.111h12.444a.78.78 0 0 0 .778-.778 7 7 0 0 0-14 0 .78.78 0 0 0 .778.778M7 10.889a5.45 5.45 0 0 1 5.389 4.667H1.611A5.45 5.45 0 0 1 7 10.889",
        "data-name": "Path 1710"
      })
    ], -1)
  ])))
}
export default { render: render }